import {createProjectModel} from 'crm/utils/project-model'
import {
    list,
    remove,
    taskConfig,
    updateTaskConfig,
    publish,
    exportData,
    exportDrainageData,
} from './service'

const model = createProjectModel({
    projectNamespace: 'taskManagement',
    state: {
        tableData: {},
        taskConfig: {},
    },
    effects: {
        *list(_, {select, put, call}) {
            const {tableData} = yield select((allState) => allState[model.namespace])
            const newParams = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }

            if (newParams.time) {
                newParams.expire_time_begin = newParams.time[0]
                    ? `${newParams.time[0]} 00:00:00`
                    : undefined
                newParams.expire_time_end = newParams.time[1]
                    ? `${newParams.time[1]} 23:59:59`
                    : undefined
            }
            delete newParams.time

            const res = yield call(list, newParams)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = res?.pagination?.rows_found || 0
                },
            })
        },
        *taskConfig(_, {call, put}) {
            const res = yield call(taskConfig)
            yield put({
                type: 'setProperty',
                payload: {
                    taskConfig: res?.data,
                },
            })
            return res
        },
        *updateTaskConfig({payload}, {call}) {
            return yield call(updateTaskConfig, payload)
        },
        *remove({payload}, {call}) {
            return yield call(remove, payload)
        },
        *publish({payload}, {call}) {
            return yield call(publish, payload)
        },
        *exportData({payload}, {call}) {
            return yield call(exportData, payload)
        },
        // 导出引流物料
        *exportDrainageData({payload}, {call}) {
            return yield call(exportDrainageData, payload)
        },
    },
    reducers: {},
})

export default model
